import { handleRequest } from "../utilities/requestHandler";

export const getProductsBySiteId = (req_body) =>
    handleRequest("post","/products/bysiteid",req_body);

export const getBestSellersBySite = (req_body) =>
    handleRequest("post", "/products/best-sellers", req_body);
